import axios from "axios";
import { Apis, BaseUrl } from "../../config";
import { toast } from "react-toastify";
import { getSession } from "../authActions";

export const getBankList = () => async (dispatch) => {
  const { token, user_profile_id, role_id } = getSession();

  dispatch({ type: "banklist_req" });
  try {
    const response = await axios.get(
      `${BaseUrl}${Apis.banklist}${user_profile_id}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params: { sys_user_id: user_profile_id, role_id: role_id }

      },
    );
    dispatch({ type: "bankList_success", payload: response.data });
  } catch (error) {
    dispatch({
      type: "bankList_failure",
      payload: error.response.data,
    });

    //toast.error(error.response.data.usr.message);
  }
};

export const addBankDetails = (values) => async (dispatch) => {
  const { token } = getSession();

  dispatch({ type: "add_bank_req" });
  try {
    const response = await axios.post(`${BaseUrl}${Apis.bankdetails}`, values, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    dispatch({ type: "add_bank_success", payload: response.data });
    toast.success(response.data.usr.message);
  } catch (error) {
    dispatch({
      type: "add_bank_failure",
      payload: error.response.data,
    });

    toast.error(error?.response?.data?.usr?.message);
  }
};

export const editBankDetails = (values, svc_bank_id) => async (dispatch) => {
  const { token, user_profile_id, role_id } = getSession();

  dispatch({ type: "edit_bank_req" });
  try {
    values.sys_user_id = user_profile_id;
    values.role_id = role_id;
    const response = await axios.put(
      `${BaseUrl}${Apis.bankdetails}/${svc_bank_id}`,
      values,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    dispatch({ type: "edit_bank_success", payload: response.data });
    toast.success(response.data.usr.message);
  } catch (error) {
    dispatch({
      type: "edit_bank_failure",
      payload: error.response.data,
    });

    toast.error(error?.response?.data?.usr?.message);
  }
};
export const deletebankList = (selectedID) => async (dispatch) => {
  const { token, user_profile_id, role_id } = getSession();

  dispatch({ type: "bankdel_req" });
  try {
    const response = await axios.put(
      `${BaseUrl}${Apis.bankdetails}/${selectedID}`,
      {
        sys_user_id: user_profile_id,
        role_id: role_id,
        svc_bank_active_yn: "N",
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    dispatch({ type: "bankDel_success", payload: response.data });
  } catch (error) {
    dispatch({
      type: "bankDel_failure",
      payload: error.response.data,
    });

    toast.error(error.response.data.usr.message);
  }
};
export const setCurrentData = (data) => (dispatch) => {
  dispatch({ type: "set_bank_details", payload: data });
};

export const updateBankTerms = (values, svc_bank_id) => async (dispatch) => {
  const { token, user_profile_id, role_id } = getSession();

  dispatch({ type: "edit_bank_req2" });
  try {
    values.sys_user_id = user_profile_id;
    values.role_id = role_id;
    const response = await axios.put(
      `${BaseUrl}${Apis.paymentTerms}/${svc_bank_id}`,
      values,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    dispatch({ type: "edit_bank_success2", payload: response.data });
    toast.success(response.data.usr.message);
  } catch (error) {
    dispatch({
      type: "edit_bank_failure2",
      payload: error.response.data,
    });

    toast.error(error?.response?.data?.usr?.message);
  }
};